import React from 'react';

const SvgUser = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 12c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4m0 1c-4.71 0-8 2.467-8 6v1h16v-1c0-3.533-3.29-6-8-6",
  fillRule: "evenodd"
}));

export default SvgUser;